var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import * as pc from "playcanvas";
var collectMaterials = function (entity, materials) {
    var e_1, _a;
    var _b;
    (_b = entity.model) === null || _b === void 0 ? void 0 : _b.meshInstances.map(function (mesh) { return mesh.material; }).forEach(function (material) { return materials.add(material); });
    try {
        for (var _c = __values(entity.children), _d = _c.next(); !_d.done; _d = _c.next()) {
            var child = _d.value;
            collectMaterials(child, materials);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
var recursivelySetMaterial = function (entity, material) {
    var e_2, _a;
    var _b;
    var meshes = (_b = entity.model) === null || _b === void 0 ? void 0 : _b.meshInstances;
    if (meshes && meshes.length > 0) {
        meshes.forEach(function (meshInstance) {
            meshInstance.material = material(meshInstance);
        });
    }
    try {
        for (var _c = __values(entity.children), _d = _c.next(); !_d.done; _d = _c.next()) {
            var child = _d.value;
            recursivelySetMaterial(child, material);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_2) throw e_2.error; }
    }
};
var transformEntityMaterials = function (entity, transformFn) {
    var materialSet = new Set();
    collectMaterials(entity, materialSet);
    var materials = Array.from(materialSet);
    var transformedMaterials = materials.map(transformFn);
    var material = function (meshInstance) {
        var index = materials.findIndex(function (material) { return material === meshInstance.material; });
        return transformedMaterials[index];
    };
    recursivelySetMaterial(entity, material);
};
var emphasizeMaterial = function (material) {
    var emphasized = material.clone();
    emphasized.diffuse.r *= 0.5;
    emphasized.diffuse.g *= 0.5;
    emphasized.diffuse.b *= 0.5;
    emphasized.update();
    return emphasized;
};
var fadeMaterial = function (material) {
    var faded = material.clone();
    faded.opacity = 0.2 * faded.opacity;
    faded.blendType = pc.BLEND_NORMAL;
    faded.update();
    return faded;
};
export var emphasizeEntity = function (entity) {
    transformEntityMaterials(entity, emphasizeMaterial);
};
export var fadeEntity = function (entity) {
    transformEntityMaterials(entity, fadeMaterial);
};
export var resetMaterial = function (entity, materialAssets) {
    var e_3, _a;
    if (entity.model && entity.model.meshInstances) {
        entity.model.meshInstances.forEach(function (meshInstance) {
            var material = materialAssets[meshInstance.material.name]
                .resource;
            meshInstance.material = material;
        });
    }
    try {
        for (var _b = __values(entity.children), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            resetMaterial(child, materialAssets);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
};
export var getMaterialAssets = function (materialAssets, materialTransforms) {
    if (!materialTransforms)
        return;
    return materialTransforms.reduce(function (acc, transform) {
        acc[transform.sourceMaterial] = materialAssets[transform.targetMaterial];
        return acc;
    }, {});
};
export var getMaterialTransformsForObjectShape = function (objectShape, useTexturedSurfaces) {
    var objectHasTexturedMaterials = objectShape.texturedMaterialTransforms !== undefined;
    if (objectHasTexturedMaterials && useTexturedSurfaces) {
        return objectShape.texturedMaterialTransforms;
    }
    return objectShape.materialTransforms;
};
export var applyMaterialTransforms = function (entity, transforms, uvScale) {
    if (!entity.model || !transforms)
        return;
    entity.model.meshInstances.forEach(function (meshInstance) {
        var materialTransformAsset = transforms === null || transforms === void 0 ? void 0 : transforms[meshInstance.material.name];
        if (materialTransformAsset) {
            var material = materialTransformAsset.resource.clone();
            if (uvScale) {
                material.diffuseMapTiling = uvScale;
                material.glossMapTiling = uvScale;
                material.normalMapTiling = uvScale;
                material.update();
            }
            meshInstance.material = material;
        }
    });
};
